import React from 'react';

import { Heading as ChakraHeading, HeadingProps as ChakraHeadingProps } from '@chakra-ui/react';
import { cn } from '@easydatasolution/ui-react/lib/utils';

interface HeadingProps extends ChakraHeadingProps {}

export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
	({ children, className, ...rest }, ref) => {
		return (
			<ChakraHeading
				className={cn('text-4xl font-semibold tracking-wide', className)}
				ref={ref}
				{...rest}
			>
				{children}
			</ChakraHeading>
		);
	},
);

Heading.displayName = 'Heading';
